module.exports = __webpack_public_path__ + "images/emoji/running_shirt_with_sash.8fb14cde2281a658e661.png";